export const CameraIcon = () => (
  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="25" fill="#00AA67" />
    <path
      d="M11 34.2222V20.3333C11 18.7992 12.2536 17.5556 13.8 17.5556H14.5C15.3813 17.5556 16.2112 17.1439 16.74 16.4444L19.848 12.3333C20.0066 12.1235 20.2556 12 20.52 12H29.48C29.7445 12 29.9934 12.1235 30.152 12.3333L33.26 16.4444C33.7888 17.1439 34.6187 17.5556 35.5 17.5556H36.2C37.7464 17.5556 39 18.7992 39 20.3333V34.2222C39 35.7564 37.7464 37 36.2 37H13.8C12.2536 37 11 35.7564 11 34.2222Z"
      stroke="white"
      strokeWidth="3.34033"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 31.4445C28.0927 31.4445 30.6 28.9571 30.6 25.8889C30.6 22.8207 28.0927 20.3334 25 20.3334C21.9072 20.3334 19.4 22.8207 19.4 25.8889C19.4 28.9571 21.9072 31.4445 25 31.4445Z"
      stroke="white"
      strokeWidth="3.34033"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
